import React from "react";
import "./TopbarWrapper.css";

const TopbarWrapper = ({children, className, ...rest}: {children: React.ReactNode, className?: string, rest?: any}) => {
  return (
    <div className={`topbar-wrapper ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default TopbarWrapper;
